import { DB } from '@services/database.service';
import { useProgramManifestStore } from '@stores/v4/useProgramManifestStore';
import { useUIStore } from '@stores/v4/useUIStore';
import { toLogicDate, toLogicTime } from '@utils/date-utils';
import { EVENT_TYPES } from '@/shared/constants/event-types.v4';

/**
 * COMPOSER ORCHESTRATOR
 * Handles complex hydration and cross-store side-effects for the Event Composer.
 * HARDENED: Using static imports for cleaner bundle chunking.
 */
export const ComposerOrchestrator = {
    /**
     * Hydrates an existing event's full context (programs, days, metadata).
     */
    async hydrateExistingEvent(event: any) {
        const start = new Date(event.start_time);
        const end = new Date(event.end_time || event.start_time);

        let parentProgramId = event.payload?.parent_program_id;
        if (!parentProgramId && event.program_day_id) {
            const programs = useProgramManifestStore.getState().programs;
            for (const p of (programs || [])) {
                const { data: days } = await DB.fetchProgramDays(p.id);
                if (days?.some((d: any) => d.id === event.program_day_id)) {
                    parentProgramId = p.id;
                    break;
                }
            }
        }

        const initialComposed: any = {
            id: event.id,
            title: event.label || "",
            type: event.type?.toUpperCase() || EVENT_TYPES.TASK,
            status: event.status?.toUpperCase() || 'PLANNED',
            startTime: toLogicTime(start),
            endTime: toLogicTime(end),
            startDate: toLogicDate(start),
            endDate: toLogicDate(end),
            programDayId: event.program_day_id,
            completed_session_id: event.completed_session_id,
            sleep_log_id: event.sleep_log_id,
            payload: { ...event.payload, parent_program_id: parentProgramId },
            preview_data: event.preview_data || {}
        };

        // 1. HYDRATE PERFORMANCE LOGS (If applicable)
        if (event.completed_session_id && (event.type === 'PERFORMANCE' || event.type === 'MOBILITY')) {
            const { data: logs } = await DB.fetchSessionDetails(event.completed_session_id, useUIStore.getState().getFKConstraint());
            if (logs) {
                initialComposed.performanceLogs = logs;
                initialComposed.payload.performanceLogs = logs;
            }
        }

        return initialComposed;
    }
};
